import {sourceActionTypes} from '../_constants';
import {sourceHelper} from "../_helpers";

export function sources(state = {}, action) {
  switch (action.type) {

    // get current user's sources request
    case sourceActionTypes.GET_SOURCES_REQUEST:
      return {
        loading: true
      };

    // get user's sources  success
    case sourceActionTypes.GET_SOURCES_SUCCESS:
      return {
        loaded: true,
        list: action.sources
      };

    // get user's sources failure
    case sourceActionTypes.GET_SOURCES_FAILURE:
      return { 
        error: action.error
      };

    // the source gets updated from the details component, propagate the changes in the list too
    case sourceActionTypes.EDIT_SOURCE_SUCCESS:
      return {
        ...state,
        list : sourceHelper.updateSourceList(state.list, action.updatedSource)
      };

      // deactivate a source success - update the list
    case sourceActionTypes.DEACTIVATE_SOURCE_SUCCESS:
      return {
        ...state,
        list : sourceHelper.updateSourceList(state.list, action.updatedSource)
      };

      // activate a source success - update the list
    case sourceActionTypes.ACTIVATE_SOURCE_SUCCESS:
      return {
        ...state,
        list : sourceHelper.updateSourceList(state.list, action.updatedSource)
      };

    default:
      return state
  }
}